export { default as DetalleCierreMensual } from "./DetalleCierreMensual";
